<template>
<div>
   <Top/>   
   <!-- content starts here -->
  <Content :reff="reff"/>
</div>
</template>

<script>
import Top from './components/Top.vue';
import Content from './Content.vue';
export default {
  name: 'Mainform',
  components:{
      Top,
     Content,
  },
  data() {
      return {
         reff:''
      }
  },
  methods: {
  },
  mounted() {
    if(this.$route.query.ref){
        this.reff = this.$route.query.ref
      }
  },
}
</script>
<style scoped>

</style>
